import React from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="bg-black text-white pt-40 pb-20 px-6 rounded-b-3xl">
      <div className="mx-auto max-w-6xl text-center">
        {/* Main Heading */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-6 tracking-tight font-mosans max-w-4xl mx-auto">
          CREATE. CONNECT. GROW.
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-8 font-inter">
          Expert influencer marketing, talent management, PR, and performance marketing services. 
          Connect with top creators and grow your brand with data-driven campaigns.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a href="#contact">
            <Button className="bg-[#E91E8C] hover:bg-[#D1197B] text-white rounded-full px-8 py-6 text-lg font-semibold font-inter">
              Book a Call
            </Button>
          </a>
        </div>

        {/* Hero Image Placeholder - you can replace this with hero.avif */}
        {/* <div className="mt-16 hidden md:block">
          <img
            src="/hero.avif"
            alt="Lxdia Dashboard"
            className="rounded-2xl shadow-2xl w-full max-w-5xl mx-auto"
            onError={(e) => {
              // Fallback to a placeholder if hero.avif is not found
              e.target.src = "https://cdn.prod.website-files.com/5ef4691542433bca43839ceb/68344e756f6cb66a17259301_hero_image.avif";
            }}
          />
        </div> */}
      </div>
    </section>
  );
};

export default HeroSection;
